export const items = [
    {
        question: 'Як це табір без телефонів?',
        answer: 'Ми хочемо аби твій загін став тобі справжніми бестіками, а ти зловив/-ла кайф від кожної секунди табору. Тому телефон даємо лише на годинку на день: щоб засинхронитись з батьками та закрити нагальні питання',
    },
    {
        question: 'А якщо я боюсь знайомитись?',
        answer: 'Перший день табору побудований так, що не завести нових друзів просто неможливо. Поруч з тобою завжди будуть досвідчені вожаті, які знають як допомогти тобі зафрендитись з загоном',
    },
    {
        question: 'Чи є розподіл по рівням на уроках?',
        answer: 'Звісно! Є цілих 3 групи: А2, В1 та В2/С1, тому навчання для тебе точно буде комфортним - зіро стрес',
    },
];
